module.exports = __webpack_public_path__ + "static/media/icon-image.8526c14e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/icon-image.svg
 ** module id = 366
 ** module chunks = 0
 **/